/**
* 会话逻辑，生成维护sid
  定义：在用户的一次会话操作中唯一，贯穿前后端
  生成：前端生成，存储session中
  // 生命周期逻辑暂时不考虑，逻辑尚未明确下来
  // 当前以浏览器session实际有效范围为准 2022-11-16
*/

import { SESSION_SID_KEY } from "src/constant";
import getUniqueStr from "src/utils/get-unique-str";

const MAX_STANDING_TIME = 30 * 60 * 1000;
let timer: any = null;
let lastTime = 0;
let currrentSid = '';
/**
 * 获取当前会话标识
 * @returns sid 唯一会话标识
 */
function getSid(time?: number): string {
  const evTime = time || Date.now();
  let sid = currrentSid || sessionStorage.getItem(SESSION_SID_KEY);
  let sidTime = lastTime || Number(sessionStorage.getItem(`${SESSION_SID_KEY}_t`)) || 0;

  if(!sid || (evTime - sidTime > MAX_STANDING_TIME)) {
    sid = getUniqueStr();
    sessionStorage.setItem(SESSION_SID_KEY, sid);
  }
  lastTime = evTime;
  currrentSid = sid;
  // 节流逻辑 减少频繁更新写入缓存操作
  if(!timer) {
    sessionStorage.setItem(`${SESSION_SID_KEY}_t`, String(evTime));
    timer = setTimeout(() => {
      timer = null;
    }, 1000);
  }
  return sid;
}

/**
 * 获取当前会话ID, 不存在或会话过期时返回null
 * @returns sid {string | null} 当前会话id
 */
function getCurrentSid() {
  const evTime = Date.now();
  let sid = currrentSid || sessionStorage.getItem(SESSION_SID_KEY);
  let sidTime = lastTime || Number(sessionStorage.getItem(`${SESSION_SID_KEY}_t`)) || 0;

  if(!sid || (evTime - sidTime > MAX_STANDING_TIME)) {
    return null;
  }
  return sid;
}

export default {
  getSid,
  getCurrentSid,
}
